// This function was used when MemSQL Studio was still using Flow to merge
// objects. It is no longer necessary and could be replaced with { ...a, ...b }
// everywhere it's used. To avoid breaking git blame too much for now, we're
// keeping this function as is.

export default function<T>(a: T, ...b: Array<Partial<T>>): T {
    return Object.assign({}, a, ...b);
}
